/* eslint-disable react/prop-types */
// @flow

// Standard Pakete
import * as React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/rail.css'
import { hot } from 'react-hot-loader'

// hinzugefügte Pakete
import Masthead from '@ta-interaktiv/react-masthead'
import Cover from '../cover'
import FeedbackMessage from '@ta-interaktiv/react-feedback-message'
import ShareButtons, { displayTypes } from '@ta-interaktiv/react-share-buttons'
import { PolymorphicCopyrightNotice } from '@ta-interaktiv/react-copyright-notice'
import { TimestampFormatter } from '@ta-interaktiv/react-publication-info'
import Waypoint from 'react-waypoint'

// CSS
import 'styles/App.css'
import './style.scss'

type Props = {
  articleId: string
}

class AppComponent extends React.Component<Props> {
  static defaultProps = {
    articleId: '29546733',
    questions: [
      'Recherche: Der Flash kommt per A-Post',
      'Interview mit einem Darknet-Händler'
    ]
  }

  constructor (props) {
    super(props)
    this.trackNavClicks = this.trackNavClicks.bind(this)
    this.trackTopClicks = this.trackTopClicks.bind(this)
  }

  trackNavClicks (e) {
    let clickedText = e.currentTarget.firstChild.nodeValue
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'question: ' + clickedText
    })
  }

  trackTopClicks (e) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'toTop: '
    })
  }

  render () {
    return (
      <div className='index'>
        <Masthead inverted articleID={this.props.articleId} />
        <header className='ui vertical fitted segment first'>
          <Cover
            title='«Ich hatte plötzlich ein Couvert auf dem Schreibtisch»            '
            subtitle=''
          />
        </header>

        {/* Lead */}
        <div
          className='ui vertical fitted inverted segment dark-grey background'
          id='nav'
        >
          <div className='ui text container'>
            <p className='ta lead'>
              Im Streit um nachrichtenlose Vermögen beschafften Privatagenten
              für die Schweiz brisante Informationen in Washington und Tel Aviv.
              Dies enthüllt der damals als Krisenmanager eingesetzte Ex-Diplomat
              Thomas Borer.
            </p>
            <p className='ta author'>Martin Stoll und Interaktiv-Team</p>

            <Waypoint
              scrollableAncestor={window}
              onEnter={event => {
                if (event.previousPosition === 'below') {
                  window.dataLayer = window.dataLayer || []
                  window.dataLayer.push({
                    event: 'startReading'
                  })
                }
              }}
            />

            <div className='scenery'>
              <p>
                Es war die gravierendste aussenpolitische Krise der Schweiz seit
                dem Zweiten Weltkrieg: der Konflikt um nachrichtenlose jüdische
                Vermögen und Raubgold. Die Schweiz wurde wegen ihres Umgangs mit
                namenlosen Bankkonten, ihrer Flüchtlingspolitik und
                wirtschaftlichen Beziehungen zu Nazi-Deutschland scharf
                kritisiert.
              </p>
              <p>
                Vor 20 Jahren, am 12. August 1998, endete der Streit.
                Hinter den Kulissen schlossen Anwälte der Schweizer Grossbanken,
                US-Sammelkläger und der Jüdische Weltkongress überraschend einen
                Vergleich ab. Nur Tage zuvor hatte die Krise den Höhepunkt
                erreicht. Diplomatische Gespräche waren abgebrochen worden,
                US-Staaten drohten, den Geschäftsverkehr mit Schweizer Banken
                und Firmen auf Eis zu legen. Die rechtspopulistischen Schweizer
                Demokraten riefen zum Boykott amerikanischer und jüdischer Waren
                auf.
              </p>
              <p>
                Thomas Borer, damals 41-jährig, war vom Schweizer
                Aussendepartement als Krisenmanager eingesetzt worden. In seiner
                Villa am Zürichsee, unter einem schweren Kronleuchter, spricht
                der heutige Unternehmensberater über bis jetzt nicht publik
                gewordene Vorgänge hinter den Kulissen. Zum Beispiel über die
                wichtige Rolle, die Privatagenten spielten.
              </p>
              <p>
                <img
                  src={require('./imgs/borer.jpg')}
                  alt=''
                  className='ui centered fluid image'
                />
              </p>
              <figcaption className='ui container ta caption'>
                In seiner Villa am Zürichsee, unter einem schweren Kronleuchter,
                erzählt der heutige Unternehmensberater über bis heute nicht
                publik gewordene Vorgänge hinter den Kulissen. Bild: Philipp
                Rohner
              </figcaption>
            </div>

            <h4>
              Zur Krisenbewältigung setzen Staaten Geheimdienste ein. War Ihnen
              der Geheimdienstchef Peter Regli damals eine Hilfe?
            </h4>
            <p>
              Der Nachrichtendienst war für uns zwischen 1996 und 1997
              weitgehend nutzlos. Weder in den USA noch in Israel hatte er die
              nötigen Zugänge. Dies hat sich erst ab 1998 verbessert. Nützlicher
              war die Zusammenarbeit mit Genfer Privatbankiers und
              Wirtschaftsführern in Basel und Zürich. Diese haben Leute
              gefunden, die uns Informationen beschaffen konnten. Sie haben auch
              mal einen Informanten bezahlt. Da kam das eine oder andere Gute
              heraus.
            </p>

            <h4>Was waren damals Ihre Informationsbedürfnisse? </h4>
            <p>
              Wir wollten wissen, was die Absicht und die Zielsetzung des World
              Jewish Congress und der US-Regierung sind. Wir wollten mehr über
              die Rolle Israels wissen. Gibt es beispielsweise in der Sache
              Aufträge oder Schreiben von Regierungschef Benjamin Netanyahu an
              Bronfman, den Präsidenten des Jüdischen Weltkongresses?
            </p>

            <aside
              className='ui vertical very fitted segment widescreen hidden large screen hidden small'
              style={{ marginBottom: '1em' }}
            >
              <div className='story-hint'>
                <div className='hint-container'>
                  <strong>Der Krisenmanager</strong>
                  <p>
                    Thomas Borer (61) arbeitete von 1987 bis 2002 als Diplomat
                    im Schweizer Aussendepartement. Als Taskforce-Leiter vertrat
                    er die Interessen der Schweiz im Konflikt um nachrichtenlose
                    Vermögen aus dem Zweiten Weltkrieg.
                  </p>
                  <p>
                    1999 wurde Borer Botschafter in Berlin. Heute ist er als
                    Unternehmensberater und Lobbyist tätig.
                  </p>
                </div>
              </div>
            </aside>
            <aside
              className='ui right rail computer or lower hidden'
              style={{ top: '160%', left: '70%' }}
            >
              <div className='story-hint'>
                <div className='hint-container'>
                  <strong>Der Krisenmanager</strong>
                  <p>
                    Thomas Borer (61) arbeitete von 1987 bis 2002 als Diplomat
                    im Schweizer Aussendepartement. Als Taskforce-Leiter vertrat
                    er die Interessen der Schweiz im Konflikt um nachrichtenlose
                    Vermögen aus dem Zweiten Weltkrieg.
                  </p>
                  <p>
                    1999 wurde Borer Botschafter in Berlin. Heute ist er als
                    Unternehmensberater und Lobbyist tätig.
                  </p>
                </div>
              </div>
            </aside>

            <h4>Und da haben Sie …</h4>
            <p>
              … solche Briefschreiben bekommen. Es gab Schreiben, in denen
              Netanyahu das Vorgehen Bronfmans legitimiert hat. Es gab auch
              Schreiben, in denen er ihm gratuliert hat. Das konnten wir dann
              öffentlich machen und auf die israelische Regierung Druck ausüben.
            </p>
            <div className='scenery'>
              <p>
                Am 17. September 1998 publizierte die «Thurgauer Zeitung» einen
                Fax des israelischen Ministerpräsidenten an den Präsidenten des
                Jüdischen Weltkongresses. Eine Quelle nannte die Zeitung nicht.
                Im Schreiben bedankte sich Netanyahu für den Kampf Bronfmans
                gegen die Profiteure des Holocaust. Heute ist klar: Der Fax kam
                von der Taskforce. Nach der Publikation verlangte die Schweizer
                Regierung von Israel eine Erklärung. Sie stellte eine Reise des
                Rüstungschefs nach Israel und einen Besuch Netanyahus in der
                Schweiz infrage. Durch den Druck war Israels Staatschef
                gezwungen, die Freundschaft mit der Schweiz öffentlich zu
                bekräftigen.
              </p>
            </div>

            <h4>Sie haben einen privaten Nachrichtendienst aufgezogen?</h4>
            <p>
              Nein, nicht ich persönlich, sondern Privatpersonen. Deren
              Aktivitäten waren für die Schweiz sehr nützlich und in deren
              Interesse. Den ersten Bericht von US-Unterstaatssekretär Stuart
              Eizenstat, in dem die Schweizer als Bankiers der Nazis bezeichnet
              wurden, durfte ich erst 24 Stunden vor der Publikation lesen. Die
              Zeit war zu knapp, um darauf angemessen reagieren zu können. Beim
              zweiten Eizenstat-Bericht war das anders. Diesen Bericht haben wir
              beschafft bekommen. Ich hatte plötzlich ein Couvert auf dem
              Schreibtisch, und da war der Entwurf des Eizenstat-Berichts drin.
              Auch den Wiesenthal-Bericht hatten wir frühzeitig. Wir konnten auf
              den zweiten Eizenstat-Bericht massgeblich Einfluss nehmen, uns
              medial vorbereiten, Gegenberichte vorbereiten und aktiv die
              Medienhoheit gewinnen.
            </p>
            <p>
              <a href='https://interaktiv.tagesanzeiger.ch/2018/meili-chronologie/?openincontroller'>
                <img
                  src='https://interaktiv.tagesanzeiger.ch/2018/meili-chronologie/inline-teaser.jpg'
                  style={{ width: '100%' }}
                />
              </a>
            </p>
            <h4>
              Wäre diese Nachrichtenbeschaffung durchgesickert, hätten Sie ein
              Problem gehabt.
            </h4>
            <p>
              Natürlich waren wir vorsichtig und haben keine E-Mails
              herumgeschickt. Wir haben uns sehr oft getroffen. Ich hatte viele
              Gespräche mit Wirtschaftsführern. Bei solchen Gelegenheiten habe
              ich jeweils gesagt: Es wäre schon sehr schön, wenn ich das eine
              oder andere wüsste.
            </p>

            <h4>Sie gingen an die Grenze für die Schweiz. War das legal?</h4>
            <p>
              Wir haben nichts Verbotenes gemacht. Mein oberstes Ziel war es,
              die Interessen der Schweiz zu wahren. Das haben wir nach bestem
              Wissen und Gewissen gemacht.
            </p>

            <h4>In welchem Zustand war damals die Schweizer Volksseele?</h4>
            <p>
              Am Schluss hat sie gekocht. Anfänglich war die Sympathie noch
              aufseiten der jüdischen Organisationen. Man war der Meinung, die
              Schweizer Banken, vielleicht auch der Bundesrat, hätten während
              Jahrzehnten grosse Versäumnisse begangen. Nachdem die Angriffe von
              jüdischen Organisationen und der US-Regierung schärfer und
              objektiv gesehen unfair wurden, hat sich die Situation verändert.
              Uns wurde damals ja vorgeworfen, wir hätten den Weltkrieg um Jahre
              verlängert. Wir seien die Banker der Nazis gewesen. Das waren
              inakzeptable Vorwürfe, welche die Stimmung völlig umschlagen
              liessen.
            </p>

            <h4>Wie sind Sie Taskforce-Chef geworden?</h4>
            <p>
              Ich war damals stellvertretender Generalsekretär im
              Aussendepartement (EDA). Das Haus brannte, und die Bundesräte
              haben sich gegenseitig die heisse Kartoffel zugeworfen. Mein Chef,
              Bundesrat Flavio Cotti, hat dann die Bildung eines Krisenstabs
              angeregt. Verdiente Botschafter haben den Job als Krisenmanager
              allerdings abgelehnt. Ich wurde von Lloyd Cutler, einem bekannten
              Rechtsanwalt und Berater von Präsident Bill Clinton, ins Gespräch
              gebracht. Staatssekretär Kellenberger hat dies unterstützt. Cotti
              gab mir 48 Stunden Bedenkzeit. Wie es sich für einen Diplomaten
              gehört, habe ich Pro und Kontra abgewogen und auch Nationalrat
              Ernst Mühlemann, den Schattenaussenminister, angerufen. Seine
              Antwort war klar: «Wenn das Vaterland ruft, geht man und fragt
              nicht, ob das einem nützt.» Er hatte recht. Deshalb habe ich auch
              zugesagt.
            </p>
          </div>
          <div className='ui bigscreen container'>
            <div className='videoWrapper'>
              <iframe
                className='externalNNIFrame'
                src='https://www.tagesanzeiger.ch/extern/videoplayer/videoplayer-nn.html?params=client@tagesanzeiger|videoId@349940|showLogo@1|autoStart@0|mute@0|showAds@false|previewPath@http://server025.newsnetz.tv/349940/frame-1-349940.jpg|platform@desktop'
                allowFullScreen='true'
                scrolling='no'
                frameBorder='no'
              />
            </div>
            <figcaption className='ui container ta caption'>
              Aus Dok-FIlm «Affäre Meili – Ein Whistleblower zwischen Moral und
              Milliarden»,{' '}
              <a href='https://www.meili-story.ch/'>www.meili-story.ch</a>
            </figcaption>
          </div>

          <Waypoint
            scrollableAncestor={window}
            onEnter={event => {
              if (event.previousPosition === 'below') {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: '50ContentRead'
                })
              }
            }}
          />

          <div className='ui text container'>
            <div className='scenery'>
              <p>
                Ab Oktober 1996 änderte sich das Leben Borers grundlegend.
                Täglich um 6:30 Uhr fanden Briefings mit Bundesrat Cotti statt.
                Die Arbeitstage dauerten oft bis 24 Uhr. Am 11. Dezember 1996
                trat Botschafter Borer erstmals vor dem Bankenausschuss des
                US-Repräsentatenhauses auf. «Mein wichtigster Auftritt», sagt er
                im Rückblick, «für die Schweiz war es ein grosser Sieg, auch
                weil wir medial erstmals Oberhand hatten». Im Dezember 1996
                schlug der Task-Force-Chef an einer Sitzung im Bundeshaus West
                dem Bundesrat und Wirtschaftsführern eine schnelle Lösung vor:
                Die Zahlung von 250 Millionen Franken per Saldo aller Ansprüche.
                Banken und Versicherungen waren dagegen. Eine solche Zahlung
                würde einer Schuldanerkennung gleichkommen, glaubten sie. Also
                schwenkte die Schweiz auf eine harte Linie um. Dabei kam es
                immer wieder zu Pannen: Ende Dezember 1996 sprach
                Bundespräsident Jean-Pascal Delamuraz in einem Interview von
                einer «Lösegeld-Erpressung». Aus jüdischen Kreisen hagelte es
                heftige Kritik. Zwei Wochen später machte der Wachtmann
                Christoph Meili Aktenvernichtungen bei der Schweizerischen
                Bankgesellschaft SBG publik. Die «SonntagsZeitung» publizierte
                Auszüge aus einem internen Lagepapier, in dem der Schweizer
                Botschafter in den USA, Carlo Jagmetti, aggressives Vokabular
                verwendete. Im selben Monat trat Jagmetti zurück.
              </p>
            </div>

            <h4>Wie haben Sie diese Tage in Erinnerung?</h4>
            <p>
              Das war wie ein ganz schlechter Film. Was schiefgehen konnte, ging
              schief. Wenn wir ein Problem halbwegs gelöst hatten, kam am
              nächsten Tag ein noch grösseres hinzu. Schlimm war, dass all dies
              vermeidbar gewesen wäre.
            </p>

            <h4>Vermeidbar?</h4>
            <p>
              Von Meili würde heute niemand mehr sprechen, wenn wir ihm damals
              einen grossen Blumenstrauss für seine Frau, einen kleinen Check
              für seine Umtriebe und eine grosse Kiste Schokolade übergeben
              hätten. Das hat Bundesrat Cotti aber nicht begriffen, und der
              damalige SBG-Chef Studer schon gar nicht. Für mich war
              offensichtlich, dass die Amerikaner den Whistleblower Meili lieben
              würden, den kleinen Kämpfer, der ein grosses Verbrechen öffentlich
              gemacht hat. Und Delamuraz: Ich weiss nicht, was ihn da geritten
              hat. Es dauerte geschlagene zwölf Tage, bis er sich für seine
              Aussagen entschuldigte. Schliesslich noch Jagmetti: Das war gemein
              (lacht).
            </p>

            <h4>
              Der Jagmetti-Bericht landete tatsächlich bei der
              «SonntagsZeitung». Wir waren der Meinung, dass die kriegerischen
              Worte der Lageanalyse eine Denkweise verrät, die im Gegensatz
              steht zum offiziell vertretenen Standpunkt der Regierung.
            </h4>
            <p>
              Das waren ja vertrauliche Berichte an mich. Diplomaten haben
              damals oft harte Worte benutzt. Jagmetti war auch Oberst. Da
              beschreibt man mal «Krieg». Seine Einschätzung war richtig.
              Letztlich war es – ich stehe zu dem Wort – fast eine kriegerische
              Auseinandersetzung mit anderen Mitteln.
            </p>

            <div className='scenery'>
              <p>
                1997 werden die Streitverhandlungen immer schwieriger. Im März
                1998 droht Edgar Bronfman, der Präsident des World Jewish
                Congress: «Wir kommen nun an einen Punkt, an dem die
                Angelegenheit erledigt werden muss. Oder wir kommen zum totalen
                Krieg.» Im Juli beschliessen US-Bundesstaaten Sanktionen gegen
                Schweizer Firmen. Die Schweizer Wirtschaftsführer treffen sich
                zu einem vertraulichen Krisengipfel in der Nationalbank in
                Zürich.
              </p>
            </div>

            <h4>Wie hat sich die Schweiz in dieser Phase verhalten?</h4>
            <p>
              Wirtschaftsführer haben auf uns gehört und ab 1998 hartes Lobbying
              betrieben. Die Schweiz war einer der grössten Investoren in den
              USA. Novartis und die Banken beschäftigten in New Jersey mehr als
              20’000 Mitarbeiter. Firmenmitarbeiter wurden losgeschickt. Sie
              nahmen Einfluss auf den Gouverneur, die Senatoren und die
              Kongressabgeordneten. Ihre Botschaft war klar: Die Schweiz macht
              das Richtige. Werden Sanktionen ergriffen, wird sich die Firma
              überlegen, den Standort zu wechseln. So kamen die jüdischen
              Organisationen nicht zu einem «Free Lunch», denn im Parlament gab
              es plötzlich Abgeordnete, die sagten: «Die Schweiz macht ja das
              Richtige.»
            </p>

            <h4>Sie waren der Dirigent dieses Orchesters? </h4>
            <p>
              Ich stand an der Spitze einer Superorganisation, der Taskforce.
              Wir haben in Zusammenarbeit mit Spezialisten aus der Wirtschaft
              auch ein Programm entworfen, das nachhaltige PR- und
              Lobby-Aktivitäten für vier Jahre mit einem Budget von 100
              Millionen Franken vorgesehen hat. Die Wirtschaft hätte das
              finanziert. Weil es überraschend zum Vergleich kam, wurde das
              Programm leider nicht mehr umgesetzt. Wir haben es versäumt, für
              die Schweiz langfristig ein «Goodwill-Reservoir» aufzubauen, das
              wir auch später, insbesondere beim Steuerstreit mit den USA,
              gebraucht hätten.
            </p>

            <h4>Hat die Schweiz aus dieser Krise gelernt?</h4>
            <p>
              Das Ernüchternde, Deprimierende für mich ist, dass die Schweiz,
              die Regierung und die Banken wenig gelernt haben. Es fing schon
              damit an, dass der Bundesrat im März 1999, als die Taskforce
              aufgelöst wurde, von mir keinen Schlussbericht wollte. Auch die
              Banker haben keine Lehren daraus gezogen. Im Streit um die
              nachrichtenlosen Vermögen hätten wir in den USA Freunde gebraucht.
              Wir konnten auf keinen einzigen zählen. Die Schaffung eines
              Goodwill-Reservoirs in den USA war eigentlich beschlossene Sache.
              Die Pharma- oder die Maschinenindustrie waren bereit, hier einiges
              zu leisten. Aber die Banken haben gesagt: Jetzt haben wir bezahlt,
              das reicht. 2007 hat die Geschichte die Banken mit dem Streit über
              die Steuerhinterziehung in den USA dann erneut eingeholt. Sie
              waren schlecht vorbereitet, hatten keine Strategie, kaum
              US-Unterstützung, und am Ende hat dies die Schweizer
              Bankenindustrie noch mal drei bis vier Milliarden gekostet.
            </p>

            <aside
              className='ui vertical very fitted segment widescreen hidden large screen hidden small'
              style={{ marginBottom: '1em' }}
            >
              <div className='story-hint'>
                <div className='hint-container'>
                  <strong>
                    «Affäre Meili – Ein Whistleblower zwischen Moral und
                    Milliarden»
                  </strong>
                  <br />
                  Ein brisanter Aktenfund macht aus einem Wachmann einen
                  Whistleblower, aus einem Sonderbotschafter einen TV-Star und
                  reisst ein neutrales Land in eine Staatsaffäre. Der von Daniel
                  von Aarburg realisierte Dokumentarfilm feiert Mitte August
                  Premiere.
                  <ul>
                    <li>
                      16. August 2018, 20.15 Uhr, Premiere im Kino Le Paris in
                      Zürich mit Podiumsgespräch einiger Protagonisten.
                    </li>
                    <li>
                      23. August 2018, 20.05 Uhr, Ausstrahlung am Schweizer
                      Fernsehen SRF 1, das den Film koproduziert hat.
                    </li>
                    <li>
                      Und ab sofort als Webstory unter{' '}
                      <a href='https://www.meili-story.ch/'>
                        www.meili-story.ch
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </aside>
            <aside
              className='ui right rail computer or lower hidden'
              style={{ top: '380%', left: '70%' }}
            >
              <div className='story-hint'>
                <div className='hint-container'>
                  <strong>
                    «Affäre Meili – Ein Whistleblower zwischen Moral und
                    Milliarden»
                  </strong>
                  <br />
                  Ein brisanter Aktenfund macht aus einem Wachmann einen
                  Whistleblower, aus einem Sonderbotschafter einen TV-Star und
                  reisst ein neutrales Land in eine Staatsaffäre. Der von Daniel
                  von Aarburg realisierte Dokumentarfilm feiert Mitte August
                  Premiere.
                  <ul>
                    <li>
                      16. August 2018, 20.15 Uhr, Premiere im Kino Le Paris in
                      Zürich mit Podiumsgespräch einiger Protagonisten.
                    </li>
                    <li>
                      23. August 2018, 20.05 Uhr, Ausstrahlung am Schweizer
                      Fernsehen SRF 1, das den Film koproduziert hat.
                    </li>
                    <li>
                      Und ab sofort als Webstory unter{' '}
                      <a href='https://www.meili-story.ch/'>
                        www.meili-story.ch
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </aside>

            <h4>
              Das hehre Ziel war es, Gerechtigkeit herzustellen. Wurde dies
              erreicht?
            </h4>
            <p>
              Nein. Am Schluss haben die Angriffe der jüdischen Organisationen
              und Eizenstats zu einer solchen Verhärtung in der Schweiz geführt,
              dass ein Hinterfragen der eigenen Geschichte und der eigenen
              Handlungen nicht mehr möglich war. Zudem war die Geldverteilung
              teilweise ein Skandal. Es gab Korruption und Misswirtschaft.
              Jüdische Exponenten haben sich persönlich bereichert und mussten
              dafür bestraft werden. Aber das hat die Schweiz nicht zu
              verantworten. Ich habe den Schweizer Bankern immer empfohlen, ja
              nichts mit der Geldverteilung zu tun zu haben. Den Rat befolgten
              sie zum Glück.
            </p>
          </div>
          <p className='spaced'>&nbsp;</p>
        </div>

        {/* Waypoint */}
        <Waypoint
          scrollableAncestor={window}
          onEnter={event => {
            if (event.previousPosition === 'below') {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'contentBottom'
              })
            }
          }}
        />

        {/* Chapter 2 */}
        <main className='ui vertical very fitted segment interview'>
          <div className='ui text container' style={{ marginTop: '1em' }}>
            <p className='spaced'>&nbsp;</p>
            <h3>Was geschah wann?</h3>

            <ul className='timeline'>
              <li>
                <h4>
                  <i className='circle icon large' /> 7. Februar 1996
                </h4>
                <p>
                  Schweizer Banken publizieren eine Erhebung zu nachrichtenlosen
                  Vermögen aus der Nazi-Zeit. Sie nennen 775 Konti mit 38,7
                  Millionen Franken Guthaben - ein für jüdische Organisationen
                  «unakzeptables», weil viel zu tiefes Ergebnis.
                </p>
              </li>
              <li>
                <h4>
                  <i className='circle icon large' /> 3. Oktober 1996
                </h4>
                <p>
                  Eine Klage von Naziopfern gegen Schweizer Banken über 20
                  Milliarden Dollar wird eingereicht.
                </p>
              </li>

              <li>
                <h4>
                  <i className='circle icon large' /> 25. Oktober 1996
                </h4>
                <p>
                  Die «Taskforce Schweiz – Zweiter Weltkrieg» unter Botschafter
                  Thomas Borer wird eingesetzt.
                </p>
              </li>

              <li>
                <h4>
                  <i className='circle icon large' /> 11. Dezember 1996
                </h4>
                <p>
                  Erklärung von Thomas Borer vor dem Bankenausschuss des
                  US-Repräsentantenhauses.
                </p>
              </li>

              <li>
                <h4>
                  <i className='circle icon large' /> 19. Dezember 1996
                </h4>
                <p>
                  Der Bundesrat setzt eine unabhängige Expertenkommission unter
                  dem Vorsitz des Schweizer Historikers Jean-François Bergier
                  ein. Sie untersucht das Verhältnis der Schweiz zu
                  Nazideutschland.
                </p>
              </li>

              <li>
                <h4>
                  <i className='circle icon large' /> 31. Dezember 1996
                </h4>
                <p>
                  Bundespräsident Delamuraz spricht öffentlich von
                  «Lösegeld-Erpressung» und löst in jüdischen Kreisen heftige
                  Reaktionen aus.
                </p>
              </li>

              <li>
                <h4>
                  <i className='circle icon large' /> 14. Januar 1997
                </h4>
                <p>
                  Wachmann Christoph Meili macht Aktenvernichtungen in der
                  Bankgesellschaft publik.
                </p>
              </li>

              <li>
                <h4>
                  <i className='circle icon large' /> 26. Januar 1997
                </h4>
                <p>
                  Die «SonntagsZeitung» veröffentlicht Auszüge aus einem Papier
                  des Schweizer Botschafters in den USA, Carlo Jagmetti. Er
                  tritt am nächsten Tag zurück.
                </p>
              </li>

              <li>
                <h4>
                  <i className='circle icon large' /> 5. Februar 1997
                </h4>
                <p>
                  Die drei Schweizer Grossbanken stellen 100 Millionen Franken
                  für einen humanitären Fonds zugunsten der Naziopfer zur
                  Verfügung.
                </p>
              </li>

              <li>
                <h4>
                  <i className='circle icon large' /> 7. Mai 1997
                </h4>
                <p>
                  US-Unterstaatssekretär Stuart Eizenstat wirft der Schweiz vor,
                  mit ihrem Verhalten den Krieg verlängert zu haben. Die
                  Taskforce reagiert sofort, der Bundesrat 15 Tage später.
                </p>
              </li>

              <li>
                <h4>
                  <i className='circle icon large' /> 10. März 1998
                </h4>
                <p>
                  Edgar Bronfman, der Präsident des World Jewish Congress, droht
                  der Schweiz mit dem «totalen Krieg».
                </p>
              </li>

              <li>
                <h4>
                  <i className='circle icon large' /> 2. Juni 1998
                </h4>
                <p>
                  Der zweite Eizenstat-Bericht zur Schweiz, zu Argentinien und
                  weiteren Ländern wird veröffentlicht. Der Bundesrat reagiert
                  gleichentags mit einer Stellungnahme.
                </p>
              </li>

              <li>
                <h4>
                  <i className='circle icon large' /> 2. Juli 1998
                </h4>
                <p>
                  New York und weitere US-Bundesstaaten beschliessen, Sanktionen
                  gegen Schweizer Banken und Firmen stufenweise in Kraft zu
                  setzen.
                </p>
              </li>

              <li>
                <h4>
                  <i className='circle icon large' /> 12./13. August 1998{' '}
                </h4>
                <p>
                  Schweizer Grossbanken, Sammelkläger und jüdische
                  Organisationen schliessen einen Vergleich in der Höhe von über
                  1,25 Milliarden Dollar.
                </p>
              </li>

              <li>
                <h4>
                  <i className='circle icon large' /> 31. März 1999
                </h4>
                <p>
                  Die «Taskforce Schweiz – Zweiter Weltkrieg» wird aufgelöst.
                </p>
              </li>

              <li>
                <h4>
                  <i className='circle icon large' /> 17. Juli 2001
                </h4>
                <p>
                  Richter Edward Korman gibt die ersten Zahlungen über 43
                  Millionen Dollar an jüdische Kläger frei.
                </p>
              </li>

              <li>
                <h4>
                  <i className='circle icon large' /> 31. März 2011
                </h4>
                <p>
                  Das Claims Resolution Tribunal, das von Zürich aus die
                  Verteilung der Vergleichsmilliarde vornimmt, löst seine Büros
                  auf. Laut Kritikern fanden sich nicht genügend berechtigte
                  Antragsteller, sodass die Vergabekriterien laufend aufgeweicht
                  wurden. Ein Schlussbericht steht noch immer aus.
                </p>
              </li>
            </ul>

            <p className='spaced'>&nbsp;</p>
          </div>
        </main>

        {/* Waypoint */}
        <Waypoint
          scrollableAncestor={window}
          onEnter={event => {
            if (event.previousPosition === 'below') {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'pageBottom'
              })
            }
          }}
        />

        {/* footer */}
        <footer className='ui vertical segment'>
          <div className='ui container'>
            <div className='ui two column divided stackable inverted grid'>
              <div className='center aligned row teaser-section'>
                <a href='https://interaktiv.tagesanzeiger.ch'>
                  <img
                    src='https://interaktiv.tagesanzeiger.ch/inline-teaser.gif'
                    className='portfolio-teaser'
                  />
                </a>
              </div>
              <div className='stretched aligned row'>
                <div className='column'>
                  <table className='ui definition very basic small inverted infographic table'>
                    <tbody>
                      <tr>
                        <td>Interview</td>
                        <td>Martin Stoll</td>
                      </tr>
                      <tr>
                        <td>Digitales Konzept, Umsetzung</td>
                        <td>Mathias Lutz, Interaktiv-Team</td>
                      </tr>
                      <tr>
                        <td>Veröffentlicht</td>
                        <td>
                          <TimestampFormatter timestamp={1534042920} />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className='column'>
                  <FeedbackMessage mailTo='interaktiv@tages-anzeiger.ch' />
                  <div className='ui fluid share aligned container'>
                    <ShareButtons
                      articleID={this.props.articleId}
                      hashtags={['TAGrafik', 'ddj']}
                      displayType={displayTypes.VERTICAL_BUTTONS}
                    />
                  </div>
                </div>
                <div className='column'>
                  <div className='ui fluid copyright container'>
                    <PolymorphicCopyrightNotice />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    )
  }
}

export default hot(module)(AppComponent)



// WEBPACK FOOTER //
// ./src/components/main/index.js